import type { Company } from '@/types';

export function isCompanyConfigured(company: Pick<Company, 'status'>): boolean {
  return company.status === 'ACTIVE';
}

export function isCompanyPendingOnboarding(company: Pick<Company, 'status'>): boolean {
  return !isCompanyConfigured(company);
}
